import { render, staticRenderFns } from "./UpdateCertificate.vue?vue&type=template&id=59d42791"
import script from "./UpdateCertificate.vue?vue&type=script&lang=js"
export * from "./UpdateCertificate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports